export default {
  AccountNumber: 'شماره حساب',
  Bank: 'بانک',
  BranchCode: 'کد شعبه',
  BranchName: 'نام شعبه',
  HolderName: 'صاحب حساب',
  ShebaNumber: 'شماره شبا',
  verifyDate: 'تاریخ تایید',
  payDate: 'تاریخ و ساعت',
  paymentGateway: 'درگاه پرداخت',
  referenceNumber: 'شماره ارجاع',
  receiptNumber: 'شماره پیگیری',
  paymentVerified: 'وضعیت',
  paid: 'پرداخت شده',
  unpaid: 'پرداخت نشده',
  discountPercent: 'درصد تخفیف',
  maximumDiscountAmount: 'حداکثر مقدار تخفیف',
  giftCreditConvertiblePercent: 'درصد تخفیف قابل تبدیل در کارت هدیه',
  paymentDetail: 'جزئیات پرداختی',
  acceptPayment: 'تایید پرداخت',
  areYouSureYouWantToPayBelowItems: 'از پرداخت موارد زیر اطمینان دارید؟',
  configPayment: 'تنظیم پرداخت',
  payTo: 'پرداخت به {title}',
  originBankAccount: 'حساب بانکی مبدا',
  settlementAmount: 'مبلغ تسویه',
  trackingNumber: 'شماره پیگیری',
  transferStatus: 'وضعیت انتقال'
}
